




















import { Section } from './mixins';

import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';

@Component({
  components: {
    FormImageUpload: () => import('@/components/forms/ImageUpload.vue'),
  },
})
export default class SectionManuals extends Mixins(Section) {
  @Prop() readonly value!: SectionManuals;

  productMediaUpdated(media: Array<{ default: number; highlight: number; name: string; path: string }>) {
    // @ts-ignore
    this.localValue.media = media.map((file: { default: number; type: string; highlight: number; name: string; path: string }, i: number) => {
      return {
        order: i + 1,
        path: file.path,
        name: file.name,
        type: file.type,
      };
    });
  }

  get productMedia() {
    if (!this.localValue.media) {
      return [];
    }
    // @ts-ignore
    return this.localValue.media.map((media: ProductImage) => {
      return {
        path: media.path,
        name: media.name,
        type: media.type,
        default: media.order === 1 ? 1 : 0,
        highlight: media.order === 1 ? 1 : 0,
      };
    });
  }
}
